/** Datos del titular de la póliza.  */

import { UserRoleEnum } from '@/modules/core/models/enums'

export default class DentalPolicyHolderToSave {
  /** (String): Rol del titular. Ejemplo: "TA". */
  role!: UserRoleEnum

  /** (String): Nombre del titular. Ejemplo: "Raul". */
  name!: string

  /** (String): Primer apellido. Ejemplo: "Mendez". */
  firstSurname!: string

  /** (String): Segundo apellido. Ejemplo: "Sanchez". */
  secondSurname!: string

  /** (DateTime): Fecha de nacimiento. Formato: "yyyy-MM-dd". Ejemplo: "1999-06-21". */
  birthDate!: string

  /** (String): Sexo. Ejemplo: "M". */
  sex!: string

  /** (String): Tipo de calle. Ejemplo: "Avenida". */
  streetType!: string

  /** (String): Nombre de la calle. Ejemplo: "Rocinante". */
  street!: string

  /** (String): Ciudad. Ejemplo: "Leganes". */
  city!: string

  /** (String): Número de casa. Ejemplo: "5". */
  house!: string

  /** (String): Código postal. Ejemplo: "28041". */
  postalCode!: string

  /** (String): Provincia. Ejemplo: "MADRID". */
  province!: string

  /** (Integer): El tipo de vivienda del asegurado.
   * 1 -> piso
   * 2 -> casa
   */
  houseType!: 1 | 2

  /** (String, opcional): Portal. Ejemplo: "10". */
  gateway?: string

  /** (String, opcional): Escalera. Ejemplo: "---". */
  stair?: string

  /** (String, opcional): Piso. Ejemplo: "---". */
  floor?: string

  /** (String, opcional): Puerta. Ejemplo: "derecha". */
  doorway?: string

  /** (String, opcional): Resto de la dirección. Ejemplo: "---". */
  restAddress?: string

  /** (String): Correo electrónico. Ejemplo: "nttdata@gmail.com". */
  email!: string

  /** (String, opcional): Prefijo telefónico. Ejemplo: "+34". */
  prefix?: string

  /** (Integer): Teléfono móvil. Ejemplo: "666666666". */
  mobilePhone!: string

  healthPolicyNumber?: string

  constructor(data: any) {
    this.role = data.role
    this.name = data.name
    this.firstSurname = data.firstSurname
    this.secondSurname = data.secondSurname
    this.birthDate = data.birthDate
    this.sex = data.sex
    this.streetType = data.streetType
    this.street = data.street
    this.city = data.city
    this.house = data.house
    this.postalCode = data.postalCode
    this.province = data.province
    this.houseType = data.houseType
    this.gateway = data.gateway
    this.stair = data.stair
    this.floor = data.floor
    this.doorway = data.doorway
    this.restAddress = data.restAddress
    this.email = data.email
    this.prefix = data.prefix
    this.mobilePhone = data.mobilePhone
    this.healthPolicyNumber = data.healthPolicyNumber
  }
}
